import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { withRouter } from "react-router";

import { SeoRenderer } from "../../../../common/helpers/seo";

import { post } from "../../../actions/general";
import { IStateTree } from "../../../store/interfaces";
import { editUser } from "../../../store/user/actions";
import { IUser } from "../../../store/user/models";

import loadableComponent from "./loadable";

const mapStateToProps = (state: IStateTree) => ({
    user: state.user as IUser,
});

export default {
    component: withRouter(connect(mapStateToProps, { post, editUser })(injectIntl(loadableComponent))),
    renderSeo: (_store, allMessage: any, lang: string) => {
        SeoRenderer({ title: allMessage["signupProfile.title"], allMessage, lang });
    },
};
